// removed by extract-text-webpack-plugin
module.exports = {"header":"SalesLogs__header___1-bzr","customer":"SalesLogs__customer___2Mxap","date":"SalesLogs__date___13BLV","route":"SalesLogs__route___avj_k","caption":"SalesLogs__caption___20gQF","table":"SalesLogs__table___30LTO","left":"SalesLogs__left___3G8qs","center":"SalesLogs__center___23HwJ","nowrap":"SalesLogs__nowrap___28LU-","log":"SalesLogs__log___3hxEE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Reports/Shellfish/SalesLogs/SalesLogs.scss
// module id = 1251
// module chunks = 1